module.exports = __webpack_public_path__ + "static/media/close-popup.689c1311.svg";